module.exports = __webpack_public_path__ + "img/logo-text.5b020709.svg";